import React from "react";
import { Link } from "react-router-dom";
import { useActiveIntegrations } from "src/scenes/dashboard/active-integrations-provider";
import { useAuth } from "./providers/auth-context";
import DemoBar from "./demo-bar";

const DemoBarEnterprise = () => {
    const { isLoading, userHasEnterpriseSubscription, isDemo, isUserPayingCustomer } = useAuth();

    const { activeIntegrations } = useActiveIntegrations();

    if (isLoading) return null;
    if (isDemo || !isUserPayingCustomer) return null;

    const anyActiveIntegration =
        !activeIntegrations ||
        !activeIntegrations.data ||
        activeIntegrations.data.integrations.find((int) => int.connected);

    if (userHasEnterpriseSubscription && anyActiveIntegration) return null;
    if (!userHasEnterpriseSubscription) return null;

    const getUpgradeTo = () => {
        if (!anyActiveIntegration)
            return (
                <>
                    <Link to="/setup-wizard" style={{ color: "#7c1374" }}>
                        Complete setup
                    </Link>{" "}
                    by using the setup wizard.
                </>
            );
        return null;
    };

    return (
        <DemoBar>
            You are currently on <strong>Demo Mode</strong>. {getUpgradeTo()}
        </DemoBar>
    );
};

export default DemoBarEnterprise;
